/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class VehiclesDashboardController {
        public static $inject : string[] =  [
            '$dealerwareSolrSearchVehicleCollection',
            '$timeout',
            '$state',
            '$stateParams'
        ];

        public searchText: string;

        constructor(public $dealerwareSolrSearchVehicleCollection: any,
                    public $timeout: any,
                    public $state: any,
                    public $stateParams: any) {
            var _self = this;

            if (this.$stateParams && this.$stateParams.hasOwnProperty('searchText') && this.$stateParams.searchText) {
                this.$timeout(function() {
                    _self.searchText = _self.$stateParams.searchText;
                }, 1000);
            }
        }

        public goToVehicleDetails(record : any) : void {
            this.$state.go('shortcuts.vehicleDetails', { vehicleId: record.data.id });
        }
    }

    getDealerwareWebContentModule().controller('VehiclesDashboardController', VehiclesDashboardController);
}
